export enum CompanyTypeEnum {
  Admin = 1,
  BodyShop = 2,
  Insurer = 3,
  Supplier = 4,
  Supervisor = 5,
  Valuator = 6,
  Other = 99, // This option does not exist in the base, it is only used on public routes
}
